var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "campusDynamic-page" }, [
    _vm.screenType == 0
      ? _c(
          "div",
          { staticClass: "cross" },
          [
            _vm.currentData && _vm.currentData.showTypeValue == 1
              ? _c("graphicCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
            _vm.currentData && _vm.currentData.showTypeValue == 2
              ? _c("pureTextCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
            _vm.currentData && _vm.currentData.showTypeValue == 4
              ? _c("bigCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
            _vm.currentData && _vm.currentData.showTypeValue == 3
              ? _c("videoCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "vertical" },
          [
            _vm.currentData && _vm.currentData.showTypeValue == 1
              ? _c("graphicCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
            _vm.currentData && _vm.currentData.showTypeValue == 2
              ? _c("pureTextCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
            _vm.currentData && _vm.currentData.showTypeValue == 4
              ? _c("bigCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
            _vm.currentData && _vm.currentData.showTypeValue == 3
              ? _c("videoCampusDynamic", {
                  attrs: { screenType: _vm.screenType, data: _vm.currentData },
                })
              : _vm._e(),
          ],
          1
        ),
    _c(
      "div",
      {
        staticClass: "left",
        class: _vm.screenType == 1 ? "verticalLeft" : "",
        on: { click: _vm.clickCrossLeftImg },
      },
      [
        _c("dsf-icon", {
          staticClass: "icon-fanyezuobeifen8",
          class: _vm.leftClouldRedClass,
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "right",
        class: _vm.screenType == 1 ? "verticalRight" : "",
        on: { click: _vm.clickCrossRightImg },
      },
      [
        _c("dsf-icon", {
          staticClass: "icon-fanyezuobeifen5",
          class: _vm.rightClouldRedClass,
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }